"use client";
import dayjs from "dayjs";
import Image from "next/image";
import React from "react";
import { useIntl } from "react-intl";
import CurrencySymbol from "@/Components/Common/CurrencySymbol/CurrencySymbol";
import { _eventBus } from '../../../core/events/EventBus';
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { useRecState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IStationDetail } from "../../../Orchestrator/Types/Index";
import "./PopularTrips.css";

interface PopularTripProps {
  trip: IStationDetail;
  stationCode: string,
  stationName: string
}

const PopularTrips: React.FC<PopularTripProps> = ({ trip, stationCode, stationName }) => {
  const intl = useIntl();
  const [isAuthenticated] = useRecState<boolean>("isAuthenticatedStateAtom");
  const [popularTripsPrice] = useRecState("popularTripsPriceAtom");

  // Find the price for this trip
  const priceObj = (Array.isArray(popularTripsPrice) ? popularTripsPrice : [])?.find((item: any) => item.from === stationCode && item.to === trip.code);

  const onTripClick = (trip: IStationDetail) => {
    if (stationCode && trip.code) {
      _eventBus.emit({
        eventName: evtTree.NetowrkDetail.Trip.Click,
        data: {
          originCode: stationCode, destinationCode: trip.code,
          searchData: {
            from: stationCode,
            to: trip.code,
            fromName: stationName,
            toName: trip.name,
            passengers: { adults: 1 },
            outboundDate: dayjs(),
            inboundDate: null,
          },
          isAuthenticated: isAuthenticated
        }
      });
    }
  };

  return (
    <div className="destination_card">
      <div className="destinations_img">
        <Image
          // src="/images/default_city.svg"
          src={
            trip?.image?.[0]?.formats?.medium?.url ||
            trip?.image?.[0]?.url ||
            "/images/destination_img.jpg"
          }
          alt=""
          width={385}
          height={289}
          layout="responsive"
        />
      </div>
      <div className="destinations__cnt">
        <div className="content_in">
          <div className="cont_left">
            <h4>{trip?.name}</h4>
            {priceObj && priceObj.price ? (
              <p className="price">
                {intl.formatMessage({ id: "from" })} <bdi dir={intl.locale === 'ar' ? 'rtl' : 'ltr'}>{priceObj.price} </bdi><CurrencySymbol />
              </p>
            ) : null}

          </div>
          <div className="price-arrow" onClick={() => { onTripClick(trip) }} style={{ cursor: 'pointer' }}>
            <Image
              src="/assets/network_icons/chevron_right.svg"
              width={10}
              height={17}
              alt="arrow"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopularTrips;
